export function registerServiceWorker() {
    if (!import.meta.env.PROD)
        return;

    if (!("serviceWorker" in navigator))
        return;

    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js", {
            scope : "/",
            type  : "module",
        }).catch((error: unknown) => {
            console.warn("[LogsCord] Service worker registration failed.", error);
        });
    }, {
        once: true,
    });
}
